export enum INVENTORY_STATUS {
  AVAILABLE = 'AVAILABLE',
  DECOMMISSIONED = 'DECOMMISSIONED',
  ALLOCATE = 'ALLOCATE',
}

export enum INVENTORY_REFERENCE_SECTION {
  INVENTORY = 'Inventory',
  ASSET = 'Assets',
}

export enum INVENTORY_REFERENCE_CATEGORIES {
  RESOURCES = 'Resources',
  CATEGORY = 'Assets-Category',
}

export enum INVENTORY_REFERENCE_NAME_FIELD {
  NAME = 'Asset Category Name',
}

export enum INVENTORY_REFERENCE_CATEGORY_FIELD {
  CATEGORY = 'Category',
}
export enum ASSET_CATEGORY_REFERENCE_CATEGORY_FIELD {
  ASSET_CATEGORY = 'Asset Category Name',
}
